import { dispatchAction } from '@ardoq/rxbeach';
import type { SearchType } from '@ardoq/api-types';
import { type PayloadQueryGremlinSearch, queryGremlinSearch } from './actions';

export type SearchGremlin = (
  payload: PayloadQueryGremlinSearch,
  searchType: SearchType
) => void;

type GremlinSearchCommands = {
  searchGremlin: SearchGremlin;
};

export const gremlinSearchCommands: GremlinSearchCommands = {
  searchGremlin: (payload, searchType) =>
    dispatchAction(queryGremlinSearch(payload), searchType),
};
